<template>
    <UploadFichierState
      :idDemande="store.model!.id"
      :readonly
      :lov-nature-fichiers="lov.NatureFichier"
      :fichiers="model?.fichiers ?? []"
      :natures-fichiers-facultatifs="naturesFichiers.facultatifs"
      :natures-fichiers-obligatoires="naturesFichiers.obligatoires"
      :natures-fichiers-ajout-facultatifs="naturesFichiers.facultatifsDefaut"
      :nombre-fichiers-maximum="naturesFichiers.nombreFichiersMaximum"
      :nombre-fichiers-minimum="naturesFichiers.nombreFichiersMinimum"
      :fichier-add
      :fichier-remove
    >
      <DemandeTabsProa />
      <DemandeFooter
        v-if="!readonly || mustConfirm"
        canPrintCerfa
        :mustConfirm
        :canRefuse
        @save="actions.save"
        @transmit="actions.save(LevelRegleEnum.Transmettre)"
        @accept="actions.confirm(true)"
        @refuse="actions.confirm(false)"
        @print="actions.downloadCerfa"
      />
    </UploadFichierState>
</template>

<script setup lang="ts">
  import { provide } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandePROAStore } from './useDemandePROAStore'
  import DemandeTabsProa from './DemandeTabsPROA.vue'
  import { LevelRegleEnum } from '@/features/domaine/types/opco'
  import { useDemandePROAActions } from './useDemandePROAActions'
  import { DemandeFooter, UploadFichierState, useWatchModel } from '@/features/interface/demande/shared'
  import type { FichierDTO } from '@/features/api/extranet/dto/Demande/shared'
  import { PROA_INJECT, type DemandeProAActions } from './DemandePROA.type'
  import { ModuleActionKey, useModuleActions, type ModuleAction } from './steps/formation/useModuleActions'

  const store = useDemandePROAStore()
  const { meta, model, readonly, naturesFichiers, lov, mustConfirm, canRefuse } = storeToRefs(store)
  const actions = useDemandePROAActions()

  provide<ModuleAction>(ModuleActionKey, useModuleActions())
  provide<DemandeProAActions>(PROA_INJECT, actions)

  const fichierAdd = store.setupCustomUpdater<FichierDTO>((patch, fichier) => {
    patch.fichiers!.push(fichier)
  })

  const fichierRemove = store.setupCustomUpdater<FichierDTO>((patch, fichier) => {
    const index = patch.fichiers!.findIndex((item) => item.fichierUid === fichier.fichierUid)
    if (index > -1) {
      patch.fichiers!.splice(index, 1)
    }
  })

  useWatchModel(model, meta)
</script>
